import { render, staticRenderFns } from "./MisDocuments.vue?vue&type=template&id=157d939d&scoped=true&"
import script from "./MisDocuments.vue?vue&type=script&lang=js&"
export * from "./MisDocuments.vue?vue&type=script&lang=js&"
import style0 from "./MisDocuments.vue?vue&type=style&index=0&id=157d939d&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "157d939d",
  null
  
)

export default component.exports